import SuggestionItem from "./SuggestionItem";

const SuggestionList = ({ suggestions, isLoading, error, onAddFriend, isPending }) => {
    if (isLoading) return <div className="loadingText">Loading suggestions...</div>;
    if (error) return <div className="errorText">An error occurred while loading data!</div>;

    if (!suggestions || suggestions.length === 0) {
        return (
            <span className="emptyText">
                There are currently no friend suggestions for you.
            </span>
        );
    }

    return (
        <>
            {suggestions.map((user) => (
                <SuggestionItem
                    key={user.id}
                    user={user}
                    onAddFriend={onAddFriend}
                    isPending={isPending}
                />
            ))}
        </>
    );
};

export default SuggestionList;